import * as React from 'react';

import Axios from 'axios';
import { Country, ListingStatus } from '@bb/domain/dist/types';

import { ListingLabelContextType } from 'contexts';
import SearchInputComponent from './SearchInputComponent';

import SearchAdvancedComponent from './SearchAdvancedComponent';

type Status = ListingStatus | 'All';

export type Availability = 'Available' | 'All' | 'Unavailable';

export type Listing = any;

interface Props {
  search: (params: any) => any;
  isFromCountry: (country: Country) => boolean;
  labelOverrideMap: ListingLabelContextType['labelOverrideMap'];
}

interface State {
  showSearch: boolean;
  address: string;
  includeAllStatuses: boolean;
  minPrice?: number;
  maxPrice?: number;
  status?: Status;
  avail?: string;
  location?: string;
  statuses: Status[];
  availabilities: Availability[];
  locations: string[];
  pageNumber: number;
}

class SearchContainer extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      showSearch: false,
      address: '',
      includeAllStatuses: true,
      avail: 'All',
      statuses: [
        'All',
        'Exclusive',
        'Assignment',
        'Coming Soon',
        'New Construction',
        'MLS',
      ],
      availabilities: ['Available', 'All', 'Unavailable'],
      locations: ['All'],
      pageNumber: 0,
    };
    Axios.get('/org/locations', {
      withCredentials: true,
    }).then(response => {
      const locations = response.data.locationIndex;
      this.setState({
        ...this.state,
        locations: [
          'All',
          ...Object.keys(locations).map((loc: any) => locations[loc].name),
        ],
      });
    });
  }

  toggleAdvancedSearch = () => {
    this.setState({ ...this.state, showSearch: !this.state.showSearch });
  };

  search = (e: React.MouseEvent<any>) => {
    e.preventDefault();
    let locationIndex;
    if (this.state.location && this.state.location !== 'All') {
      locationIndex = this.state.locations.indexOf(this.state.location) - 1;
    }
    const params = {
      includeAllStatuses: true,
      excludePendingAndPrivate: true,
      status: this.state.status,
      location: locationIndex ?? this.state.location,
      avail: this.state.avail,
      minPrice: this.state.minPrice,
      maxPrice: this.state.maxPrice,
      address: this.state.address,
    };
    if (this.state.showSearch) {
      delete params.includeAllStatuses;
    } else {
      delete params.status;
      delete params.minPrice;
      delete params.maxPrice;
      delete params.location;
      delete params.avail;
    }

    this.props.search(params);
  };

  handleChange = (name: string) => (event: React.ChangeEvent<any>) => {
    this.setState({ ...this.state, [name]: event.target.value });
  };

  handleChecked = (name: string) => (event: React.ChangeEvent<any>) => {
    this.setState({ ...this.state, [name]: event.target.checked });
  };

  render() {
    const { labelOverrideMap, children } = this.props;

    return (
      <div>
        <div>
          {children}
          <SearchInputComponent
            {...this.state}
            search={this.search}
            toggleAdvancedSearch={this.toggleAdvancedSearch}
            handleChange={this.handleChange}
            handleChecked={this.handleChecked}
          />
        </div>
        <SearchAdvancedComponent
          {...this.state}
          labelOverrideMap={labelOverrideMap}
          search={this.search}
          handleChange={this.handleChange}
        />
      </div>
    );
  }
}

export default SearchContainer;
